import React from 'react';
import { configuration } from '../api'


/**
 * HOC that injects company configuration in the props.
 * @param {Object} props - Props from parent component.
 * @returns {Component}
 */
export default function (props) {
	return WrappedComponent => {
		function WithConfiguration(props) {
			const { pathname } = props.location || {}

			const urlParams = new URLSearchParams(props.location.search)

			const session = urlParams.get('s')

			const [config, setConfig] = React.useState({})

			React.useEffect(() => {
				if (session && !/\/b$/.test(pathname)) {
					configuration.getConfiguration(session)
					.then(({ data }) => data.configuration && setConfig(data.configuration))
				}
			// eslint-disable-next-line react-hooks/exhaustive-deps
			}, [session])

			return <WrappedComponent {...props} configuration={config} urlSession={session} />
		}

		return WithConfiguration(props);
	}

}